const environment = process.env.GATSBY_ENV ?? process.env.NODE_ENV ?? '';
const isProduction = environment === 'production';
const isStaging = environment === 'staging';
const isDevelopment = process.env.NODE_ENV === 'development';

export { isProduction, isStaging, isDevelopment, environment };
